import Vue from "vue";
import locale from "element-ui/lib/locale";
import ko from "element-ui/lib/locale/lang/ko";
import Alert from "element-ui/lib/alert";
import Badge from "element-ui/lib/badge";
import Button from "element-ui/lib/button";
import Checkbox from "element-ui/lib/checkbox";
import CheckboxGroup from "element-ui/lib/checkbox-group";
import Col from "element-ui/lib/col";
import Collapse from "element-ui/lib/collapse";
import CollapseItem from "element-ui/lib/collapse-item";
import DatePicker from "element-ui/lib/date-picker";
import Dialog from "element-ui/lib/dialog";
import Form from "element-ui/lib/form";
import FormItem from "element-ui/lib/form-item";
import Input from "element-ui/lib/input";
import InputNumber from "element-ui/lib/input-number";
import Loading from "element-ui/lib/loading";
import Menu from "element-ui/lib/menu";
import MenuItem from "element-ui/lib/menu-item";
import Message from "element-ui/lib/message";
import MessageBox from "element-ui/lib/message-box";
import Option from "element-ui/lib/option";
import Pagination from "element-ui/lib/pagination";
import Radio from "element-ui/lib/radio";
import RadioGroup from "element-ui/lib/radio-group";
import Rate from "element-ui/lib/rate";
import Row from "element-ui/lib/row";
import Slider from "element-ui/lib/slider";
import Select from "element-ui/lib/select";
import Submenu from "element-ui/lib/submenu";
import Switch from "element-ui/lib/switch";
import Table from "element-ui/lib/table";
import TableColumn from "element-ui/lib/table-column";
import TabPane from "element-ui/lib/tab-pane";
import Tabs from "element-ui/lib/tabs";
import Tag from "element-ui/lib/tag";
import TimeSelect from "element-ui/lib/time-select";
import installManagementUi from "@shared/installManagementUi.cjs";

installManagementUi({
  Framework: Vue,
  locale,
  language: ko,
  components: [
    Alert,
    Badge,
    Button,
    Checkbox,
    CheckboxGroup,
    Col,
    Collapse,
    CollapseItem,
    DatePicker,
    Dialog,
    Form,
    FormItem,
    Input,
    InputNumber,
    Menu,
    MenuItem,
    Option,
    Pagination,
    Radio,
    RadioGroup,
    Rate,
    Row,
    Slider,
    Select,
    Submenu,
    Switch,
    Table,
    TableColumn,
    TabPane,
    Tabs,
    Tag,
    TimeSelect,
  ],
  Loading,
  MessageBox,
  Message,
});
